import { useMemo } from 'react';
import { useMessagesBreadcrumbs } from '@dealstack/frontend/app/pages/Project/MIP/Messages/components/Breadcrumbs/hooks/useMessagesBreadcrumbs';
import { SummaryDealExtendedTct } from '@dealstack/shared/lib/generated';

interface Props {
	dealId?: string;
	deal?: SummaryDealExtendedTct;
	mipId?: string;
}
export const MessagesBreadcrumbs = ({ dealId, deal, mipId }: Props) => {
	const currentMip = useMemo(() => deal?.mips.find((mip) => mip.id === mipId), [deal, mipId]);

	useMessagesBreadcrumbs({ view: 'home', dealId, currentMip });

	return null;
};
